<form [formGroup]="form" (ngSubmit)="onSubmit()" autocomplete="off">

    <nav class="toolbar navbar navbar-light">
        <div class="form-inline">
            <button class="btnback btn btn-outline-success" type="button" title="Volver" (click)="onBack()"><i class="fa fa-chevron-left"></i></button>
            <button type="submit" class="btn btn-outline-success" title="Guardar"><i class="fa fa-save"></i> Guardar</button>
            <button class="btn btn-outline-success" *ngIf="puntoControl.Id > 0" type="button" title="Nueva Autoridad Control" (click)="onAddAutoridadControl()"><i class="fa fa-file-o"></i> Nueva Autoridad Control </button>
        </div>
    </nav>

    <div class="animated fadeIn container-fluid">

        <h4>{{editTitle}} Punto de Control</h4>

        <div class="row">
            <div class="col-md-12">

                <div class="card card-accent-success animated fadeIn">

                    <div class="card-body">

                        <div class="row">

                            <div class="form-group col-md-6">
                                <label class="col-form-label required-field" for="inpDescripcion">Descripción</label>
                                <input formControlName="Descripcion" name="Descripcion" title="" class="form-control"
                                       maxlength="100" [ngClass]="displayFieldCss('Descripcion')" id="inpDescripcion" type="text" value="">

                                <div class="invalid-feedback" *ngIf="isFieldInvalid('Descripcion','required')">
                                    Descripción es obligatorio
                                </div>

                                <div class="invalid-feedback" *ngIf="isFieldInvalid('Descripcion','descripcion_duplicated')">
                                    Descripción ya existe
                                </div>
                            </div>

                            <div class="form-group col-md-6">
                                <label class="col-form-label required-field" for="inpPais">País</label>

                                <ng-select loadingText="Cargando..."
                                           [items]="listPais"
                                           placeholder="-- Seleccione un País --"
                                           [readonly]="!listPais || listPais.length === 0"
                                           [loading]="!listPais || listPais.length === 0"
                                           bindLabel="Descripcion"
                                           bindValue="Id"
                                           formControlName="IdPais"
                                           notFoundText="País no encontrado"
                                           [ngClass]="displayFieldCssNgSelect('IdPais')"
                                           clearAllText="Eliminar selección">
                                </ng-select>
                                <div class="invalid-feedback d-block" *ngIf="isFieldInvalid('IdPais','required')">
                                    País es obligatorio
                                </div>
                            </div>

                        </div>

                        <div class="row">

                            <div class="form-group col-md-6">
                                <label class="col-form-label required-field" for="inpIdentificadorTraces">Identificador Traces</label>
                                <input formControlName="IdentificadorTraces" name="IdentificadorTraces" title="" class="form-control"
                                       maxlength="50" [ngClass]="displayFieldCss('IdentificadorTraces')" id="inpIdentificadorTraces" type="text" value="">

                                <div class="invalid-feedback" *ngIf="isFieldInvalid('IdentificadorTraces','required')">
                                    Identificador Traces es obligatorio
                                </div>

                                <div class="invalid-feedback" *ngIf="isFieldInvalid('IdentificadorTraces','identificadortraces_duplicated')">
                                    Identificador Traces ya existe
                                </div>
                            </div>

                            <div class="form-group col-md-6">
                                <label class="col-form-label required-field" for="inpDescripcion">Dirección</label>
                                <input formControlName="Direccion" name="Direccion" title="" class="form-control"
                                       maxlength="200" [ngClass]="displayFieldCss('Direccion')" id="inpDireccion" type="text" value="">

                                <div class="invalid-feedback" *ngIf="isFieldInvalid('Direccion','required')">
                                    Dirección es obligatorio
                                </div>
                            </div>

                        </div>


                        <div class="row">

                            <div class="form-group col-md-3">
                                <label class="col-form-label required-field" for="inpLocalidad">Localidad</label>
                                <input formControlName="Localidad" name="Localidad" title="" maxlength="150"
                                       class="form-control" [ngClass]="displayFieldCss('Localidad')" id="inpLocalidad" type="text" value="">

                                <div class="invalid-feedback" *ngIf="isFieldInvalid('Localidad','required')">
                                    Localidad es obligatorio
                                </div>
                            </div>

                            <div class="form-group col-md-3">
                                <label class="col-form-label required-field" for="inpDescripcion">Código Postal</label>
                                <input formControlName="CodigoZip" name="CodigoZip" title="" maxlength="10"
                                       class="form-control" [ngClass]="displayFieldCss('CodigoZip')" id="inpCodigoZip" type="text" value="">

                                <div class="invalid-feedback" *ngIf="isFieldInvalid('CodigoZip','required')">
                                    Código Postal es obligatorio
                                </div>
                            </div>

                            <div class="form-group col-md-6">
                                <label class="col-form-label" for="inpActivo">Activo</label>
                                <p-toggleButton class="form-control-togglebutton" formControlName="Activo"
                                                onLabel="Sí" offLabel="NO" onIcon="pi pi-check"
                                                offIcon="pi pi-times"></p-toggleButton>
                            </div>

                        </div>

                    </div>
                </div>
            </div>
        </div>

        <div class="row">
            <!-- AUTORIDADES -->
            <div class="col-md-12">

                <div class="card card-accent-success animated fadeIn">

                    <div class="card-header-buscador">
                        <i class="fa fa-plus"></i> <strong id="stAduana">Autoridades de control</strong>
                        <label class="col-form-label" for="stAutoridades"></label>
                    </div>
                    <div class="card-body-detalle-list">

                        <div class="row">

                            <div class="col-md-12">

                                <table class="table table-list table-responsive table-sm">
                                    <thead>
                                        <tr>
                                            <th class="cabecerasTablaDetalles col-md-2"></th>
                                            <!--<th class="cabecerasTablaDetalles"></th>-->
                                            <th class="cabecerasTablaDetalles col-md-4">Nombre</th>
                                            <th class="cabecerasTablaDetalles col-md-4">Cod. Traces</th>
                                            <th class="cabecerasTablaDetalles col-md-2">Activa</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr *ngFor="let item of puntoControl.TwAutoridadControlCollection">

                                            <td scope="col" class="col-md-2">
                                                <div class="btn-group">
                                                    <button type="button" (click)="onEditAutoridadControl(item)" title="Editar"
                                                            class="btn btn-sm btn-info">
                                                        <i class="fa fa-search"></i>
                                                    </button>
                                                </div>
                                                <div class="btn-group">
                                                    <button type="button" (click)="onDeleteAutoridadControl(item)"
                                                            class="btn btn-sm btn-danger">
                                                        <i class="fa fa-remove"></i>
                                                    </button>
                                                </div>
                                            </td>

                                            <td scope="col" class="col-md-4">{{item.Descripcion}}</td>
                                            <td scope="col" class="col-md-4">{{item.ReferenciaTraces}}</td>
                                            <td scope="col" class="col-md-2">{{item.Activa | siNo}}</td>
                                        </tr>

                                    </tbody>
                                </table>
                            </div>
                        </div>

                    </div>
                </div>

            </div>

            <div class="col-md-6">

            </div>
        </div>
    </div>

</form>
